<style lang="less">
  @import '../styles/menu.less';
</style>

<template>
  <div>
    <Menu ref="sideMenu" :active-name="$route.name" :open-names="openNameArr"
          @on-open-change="openChange"
          :theme="menuTheme"
          width="auto"
          @on-select="changeMenu">

      <template v-for="item in menuList" v-if="item.checked">
        <MenuItem v-if="item.meta && item.meta.signal" :name="item.children[0].name" :key="item.path">
          <Icon :type="item.icon" :size="iconSize"/>
          <span class="layout-text">{{ itemTitle(item) }}</span>
        </MenuItem>

        <Submenu v-if="item.children.length >= 1 && !item.meta.signal" :name="item.name"
                 :key="item.path">
          <template slot="title">
            <Icon :type="item.icon" :size="iconSize"></Icon>
            <span class="layout-text">{{ itemTitle(item) }}</span>
          </template>

          <Submenu name="设备通用管理" v-if="item.name == 'equipmentManage'">
            <template slot="title">设备通用管理</template>
            <template v-for="(child,index) in item.children"
                      v-if="child.checked && (child.path == 'deviceBrand' || child.path == 'deviceType' || child.path == 'deviceModel' || child.path == 'doorCtrl' || child.path == 'doorReport') ">
              <MenuItem :name="child.name" :key="index">
                <Icon :type="child.icon" :size="iconSize"></Icon>
                <span class="layout-text">{{ itemTitle(child) }}</span>
              </MenuItem>
            </template>
          </Submenu>

          <Submenu name="设备信息管理" v-if="item.name == 'equipmentManage'">
            <template slot="title">设备信息管理</template>
            <template v-for="(child,index) in item.children"
                      v-if="child.checked && (child.path == 'deviceList' || child.path == 'deviceCarNumber')">
              <MenuItem :name="child.name" :key="index">
                <Icon :type="child.icon" :size="iconSize"></Icon>
                <span class="layout-text">{{ itemTitle(child) }}</span>
              </MenuItem>
            </template>
          </Submenu>

          <template v-for="(child,index) in item.children"
                    v-if="item.name != `equipmentManage` && item.name != `orderManage` && child.checked ">
            <MenuItem :name="child.name" :key="index">
              <Icon :type="child.icon" :size="iconSize"></Icon>
              <span class="layout-text">{{ itemTitle(child) }}</span>
            </MenuItem>
          </template>

        </Submenu>
      </template>
    </Menu>
  </div>
</template>

<script>
  export default {
    name: 'sidebarMenu',
    props: {
      menuList: Array,
      iconSize: Number,
      menuTheme: {
        type: String,
        default: 'dark'
      },
      openNames: {
        type: Array
      }
    },
    data() {
      return {
        openNameArr: this.openNames
      }
    },
    mounted() {
      this.$nextTick(_ => {
        if (this.$refs.sideMenu) {
          this.$refs.sideMenu.updateActiveName();
        }
      })
    },
    methods: {
      changeMenu(active) {
        this.$emit('on-change', active);
        this.$nextTick(_ => {
          this.$refs.sideMenu.updateOpened();
          this.$refs.sideMenu.updateActiveName();
        });
      },
      openChange(name) {
        this.openNameArr = name;
      },
      itemTitle(item) {
        if (typeof item.title === 'object') {
          return item.title.i18n;
        } else {
          return item.title;
        }
      }
    },
    updated() {
      this.$nextTick(() => {
        if (this.$refs.sideMenu) {
          this.$refs.sideMenu.updateOpened();
        }
      });
    }

  };
</script>



// WEBPACK FOOTER //
// src/components/main-components/shrinkable-menu/components/sidebarMenu.vue